/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateTenantDto { 
    tenancyName: string;
    name: string;
    shortName?: string | null;
    adminEmailAddress: string;
    connectionString?: string | null;
    password?: string | null;
    isActive?: boolean;
    moduleType?: string | null;
    fullName?: string | null;
    countryCode?: string | null;
    phoneNumber?: string | null;
    userName?: string | null;
    cashTransactionFeatureEnabled?: boolean;
    registrationNumber?: string | null;
    licenceNumber?: string | null;
    address?: string | null;
    mode?: string | null;
    taxNumber?: string | null;
    kamEmail?: string | null;
    deletionDate?: string | null;
    apexId?: number | null;
}

